<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="管理员账户">
        <el-input
          v-model="formInline.adminName"
          placeholder="请输入管理员账户"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="adminName" label="用户名"> </el-table-column>
      <el-table-column prop="mobile" label="手机"> </el-table-column>

      <!-- <el-table-column prop="password" label="密码"> </el-table-column>
      <el-table-column prop="role" label="权限"> </el-table-column> -->
      <el-table-column label="最后登录时间">
        <template slot-scope="scope">
          <div>{{ scope.row.lastlogintime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row.id)"
            >删除</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
    <EditDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
      :isCreate="isCreate"
      :userInfo="userInfo"
    />
  </div>
</template>

<script>
import EditDialog from "./components/editDialog";
export default {
  components: {
    EditDialog
  },
  data() {
    return {
      formInline: {
        adminName: "",
        date: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isCreate: true,
      isDialogShow: false,
      userInfo: null,
      multipleSelection: []
    };
  },
  methods: {
    onSubmit() {
      let queryModel = {
        adminName: this.formInline.adminName,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询管理员"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    onAdd() {
      this.userInfo = null;
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleDelete(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = [id];
        this.$axios(this.$urlMapping["删除管理员"], {
          data: {
            ids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleEdit(userInfo) {
      console.log(userInfo);
      this.userInfo = userInfo;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    closeForm() {
      this.isDialogShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBatchDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let ids = this.multipleSelection.map(ele => ele.id);
          this.$axios(this.$urlMapping["删除管理员"], {
            data: {
              ids
            }
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.onSubmit();
          });
        });
      } else {
        this.$notify.info({
          title: "消息",
          message: "至少选择一条进行删除"
        });
      }
    }
  },
  mounted() {
    this.onSubmit();
  }
};
</script>

<style lang="less" scoped></style>
